<template>
    <footer
        v-if="showFooter"
        class="hide-when-printing py-3"
    >
        <div class="mb-3">
            <div
                class="mt-auto h-[54px] bg-contain bg-repeat-x legacy-md:h-[80px]"
                style="background-image: url('/images/footer-homes.png')"
            />
        </div>
        <div
            class="mx-auto flex flex-wrap items-center justify-between gap-x-4 gap-y-1 px-3 leading-8 legacy-md:w-full lg:max-w-7xl"
        >
            <span class="text-sm text-content-secondary">
                © {{ new Date().getFullYear() }} Closinglock, Inc. All rights reserved.
            </span>
            <ul class="mb-0 flex list-none flex-wrap items-center gap-x-4 leading-5 text-content-secondary">
                <li>
                    <a :href="termsCompanyUrl">Terms of service</a>
                </li>
                <li>
                    <a :href="privacyUrl">Privacy policy</a>
                </li>
            </ul>
        </div>
    </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

withDefaults(
    defineProps<{
        privacyUrl?: string;
        termsCompanyUrl?: string;
    }>(),
    {
        privacyUrl: 'https://www.closinglock.com/privacy-policy/',
        termsCompanyUrl: 'https://www.closinglock.com/terms-company',
    },
);

const route = useRoute();
const FOOTER_IMAGE_ROUTES = ['login', 'ssologin', 'user/mfa/send', 'user/mfa/verify', 'password/reset'];
const showFooter = computed(() => FOOTER_IMAGE_ROUTES.some(val => route.path.includes(val)));
</script>
